import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ShieldCheck } from 'lucide-react';
import './AboutUs.css';

function AboutUs() {
    const handleScrollToContact = () => {
        const element = document.getElementById('contact-us');
        if (element) {
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
        }
    };

    return (
        <section className="about-us" id="about-us">
            <div className="about-container">
                {/* Left Side: Image & Premium Badge */}
                <motion.div
                    className="about-image-side"
                    initial={{ opacity: 0, scale: 0.95 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                >
                    <div className="image-wrapper">
                        <img
                            src="/images/team-photo.jpg"
                            alt="CleanSweep Waste Management Team Dubai"
                            className="team-photo"
                        />

                        {/* THE ENHANCED MODERN BADGE */}
                        <div className="modern-badge">
                            <div className="badge-icon-container">
                                <ShieldCheck size={32} />
                            </div>
                            <div className="badge-text">
                                <span className="badge-title">RELIABILITY</span>
                                <span className="badge-subtitle">Guaranteed Since Day 1</span>
                            </div>
                            <div className="badge-glow"></div>
                        </div>
                    </div>
                </motion.div>

                {/* Right Side: Content & Mission */}
                <motion.div
                    className="about-content-side"
                    initial={{ opacity: 0, x: 30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8, delay: 0.2 }}
                >
                    <span className="section-tagline">Our Mission & Values</span>
                    <h2>We Not Only Collect Waste, We Deliver Peace of Mind</h2>

                    <p className="main-description">
                        In an industry where <strong>unreliable service and missed schedules</strong> are far too common, CleanSweep was born out of a simple mission: to provide the top-of-the-class service experience you actually deserve.
                    </p>

                    <p className="secondary-description">
                        We noticed the gap in quality service and decided to become your <strong>reliable partner for amazing waste management.</strong> These principles have guided us since Day 1, ensuring that with CleanSweep, you never have to worry about your waste disposal again.
                    </p>

                    <div className="features-grid">
                        <div className="feature-item">
                            <CheckCircle2 size={20} className="icon-green" />
                            <span>Customer-First Experience</span>
                        </div>
                        <div className="feature-item">
                            <CheckCircle2 size={20} className="icon-green" />
                            <span>Transparent & Honest Pricing</span>
                        </div>
                        <div className="feature-item">
                            <CheckCircle2 size={20} className="icon-green" />
                            <span>Always On-Time Collections</span>
                        </div>
                        <div className="feature-item">
                            <CheckCircle2 size={20} className="icon-green" />
                            <span>Dubai Municipality Approved</span>
                        </div>
                    </div>

                    <button className="about-cta" onClick={handleScrollToContact}>
                        Get the Service You Deserve
                    </button>
                </motion.div>
            </div>
        </section>
    );
}

export default AboutUs;